module.exports = __webpack_public_path__ + "51ad9e82ebe60d5894362c488ddf0a6d.svg";